import { render, staticRenderFns } from "./ExternalPage.vue?vue&type=template&id=161bb70a"
import script from "./ExternalPage.vue?vue&type=script&lang=js"
export * from "./ExternalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports